module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  Editor\n  "), _c('tinymce', {
    attrs: {
      "id": "editor",
      "options": _vm.editor.options,
      "content": _vm.editor.content
    },
    on: {
      "change": _vm.change
    },
    model: {
      value: (_vm.editor.text),
      callback: function($$v) {
        _vm.$set(_vm.editor, "text", $$v)
      },
      expression: "editor.text"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "name": "button1"
    },
    on: {
      "click": function($event) {
        _vm.downloadPdf()
      }
    }
  }, [_vm._v("Generate PDF")])]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_vm._v("\n          Base Url: "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pdfHtmlFileDto.baseUrl),
      expression: "pdfHtmlFileDto.baseUrl"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "baseUrl",
      "type": "text",
      "placeholder": "Base URL"
    },
    domProps: {
      "value": (_vm.pdfHtmlFileDto.baseUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pdfHtmlFileDto, "baseUrl", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }, [_vm._v("\n          Header Template:"), _c('br'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pdfHtmlFileDto.headerHtml),
      expression: "pdfHtmlFileDto.headerHtml"
    }],
    staticStyle: {
      "width": "1024px"
    },
    attrs: {
      "id": "footer",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.pdfHtmlFileDto.headerHtml)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pdfHtmlFileDto, "headerHtml", $event.target.value)
      }
    }
  }), _c('br'), _vm._v("\n          Header Output:"), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "1024px",
      "border": "1px solid black"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.pdfHtmlFileDto.headerHtml)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }, [_vm._v("\n          Footer Template:"), _c('br'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pdfHtmlFileDto.footerHtml),
      expression: "pdfHtmlFileDto.footerHtml"
    }],
    staticStyle: {
      "width": "1024px"
    },
    attrs: {
      "id": "footer",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.pdfHtmlFileDto.footerHtml)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pdfHtmlFileDto, "footerHtml", $event.target.value)
      }
    }
  }), _c('br'), _vm._v("\n          Footer Output:"), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "1024px",
      "border": "1px solid black"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.pdfHtmlFileDto.footerHtml)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }, [_vm._v("\n          Body Template:"), _c('br'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editor.text),
      expression: "editor.text"
    }],
    staticStyle: {
      "width": "1024px"
    },
    attrs: {
      "id": "footer",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.editor.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editor, "text", $event.target.value)
      }
    }
  }), _c('br')])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Debug Details")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15f16a10"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Editor.vue
// module id = 899
// module chunks = 1